<template>
  <button class="text-white rounded-full p-5 text-xl capitalize" @click="handleClick">
    {{label}}
  </button>
</template>

<script>
  export default {
    name: 'VButton',
    props: {
      label: {
        type: String,
        required: true,
      },
    },
    methods: {
      handleClick(e) {
        this.$emit('click', e);
      },
    },
  };

</script>
